<template>
  <div class="container d-flex fd-column:mo SECTION">
    <div class="HEADER-INFO p-x-2:mo">
      <h2>{{content.title}}</h2>
      <p class="p-b-4">{{content.description}}</p>
      <service-search-form
          class="p-b-3"
          :placeholderText="placeholderText"
          @limitReached="$emit('limitReached')" />
      <span class="m-b-2 m-l-1">Didn't find what you need?</span>
      <router-link
          :to="{ path: '/' , hash: '#browse' }"
          class="BUTTON btn"
      >{{content.cta}}</router-link>
    </div>
    <div class="p-y-4" >
      <img
          class="IMAGE"
          :src="image"
          :alt="altText"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ServiceSearchForm from './components/ServiceSearchForm';

export default {
  name: 'h2-hero',
  components: {
    ServiceSearchForm,
  },

  computed: {
    ...mapGetters('homepage/contentful', [
      'customerHomePage',
    ]),
    content () {
      return this.customerHomePage.heroSection;
    },
    image () {
      return this.customerHomePage.heroSection.image.fields.file.url;
    },
    altText () {
      return this.customerHomePage.heroSection.image.fields.description;
    },
    placeholderText () {
      return this.content.searchBar;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    @include desktop {
      margin: 8 * $unit auto 10 * $unit auto;
    }
  }
  .HEADER-INFO {
    max-width: 47 * $unit;
    display: flex;
    flex-direction: column;
    justify-content: left;
    margin-right: 6 * $unit;
  }
  .IMAGE {
    width:100%;
    height: auto;
  }
  .BUTTON {
    @include padding-x(4);
  @include padding-y(1);
  width: 192px;
  }
</style>
